export default __webpack_public_path__ + "static/media/tpad-logo.8c32bbac.png";